import { useQuery } from "@tanstack/react-query";
import Axios from "../../../Axios/Axios";
import { Urls } from "../../../Urls";

export const useVehicleAllocation = (
  { startDate, endDate, plant, destination, transporterId, role },
  enabled = true
) => {
  return useQuery({
    queryKey: ["vehicleAllocation", startDate, endDate, plant, destination, transporterId, role],
    queryFn: async () => {
      const params = new URLSearchParams({ start_date: startDate, end_date: endDate });
      if (plant && plant !== "All") params.append("plant", plant);
      if (destination && destination !== "All") params.append("destination", destination);
      if (transporterId && transporterId !== "All") params.append("transporter_id", transporterId);
      if (role) params.append("role", role);
      const { data } = await Axios.get(`${Urls.tmsDashboardVehicleAllocation}?${params.toString()}`);
      return data;
    },
    enabled,
    staleTime: 60 * 1000,
    refetchInterval: enabled ? 5 * 60 * 1000 : false,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
  });
};
